import { createRoot } from 'react-dom/client';
import axios from 'axios';

import './_metronic/assets/sass/style.scss';
import './_metronic/assets/sass/plugins.scss';
import './_metronic/assets/sass/style.react.scss';
import './app/modules/styles/index.scss';
import { AppRoutes } from './app/routing/AppRoutes';
import { AuthProvider, setupAxios } from './app/modules/auth';
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n';
import { patchToast } from './app/modules/utils/PatchToast';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdfjs/pdf.worker.min.js`;

setupAxios(axios);
patchToast();

const container = document.getElementById('root');

if (container) {
	createRoot(container).render(
		<MetronicI18nProvider>
			<AuthProvider>
				<AppRoutes />
			</AuthProvider>
		</MetronicI18nProvider>
	);
}
